import DocumentsWrapper from '../components/DocumentsWrapper';
import LoggedInLayout from '../components/LoggedInLayout';

function InvestorDocuments() {
   return (
      <LoggedInLayout>
         <div className="min-h-screen bg-gray-100">
            <DocumentsWrapper
               baseUrl={'me/documents'}
               accountFiltersUrl="me/accounts"
            />
         </div>
      </LoggedInLayout>
   );
}

export default InvestorDocuments;
